import { html2canvas } from '@/_models/virtualStaging/HTMLMesh/utils/html2canvas';
import { htmlevent } from '@/_models/virtualStaging/HTMLMesh/utils/htmlevent';

export const createHTMLMesh = (dom, THREE) => {
  const canvases = new WeakMap();

  class HTMLTexture extends THREE.CanvasTexture {
    constructor() {
      super(html2canvas(dom, canvases));

      this.dom = dom;

      this.anisotropy = 16;
      this.encoding = THREE.sRGBEncoding;
      this.minFilter = THREE.LinearFilter;
      this.magFilter = THREE.LinearFilter;

      // Create an observer on the DOM, and run html2canvas update in the next loop
      const observer = new MutationObserver(() => {
        if (!this.scheduleUpdate) {
          // ideally should use xr.requestAnimationFrame, here setTimeout to avoid passing the renderer
          this.scheduleUpdate = setTimeout(() => this.update(), 16);
        }
      });

      const config = { attributes: true, childList: true, subtree: true, characterData: true };
      observer.observe(dom, config);

      this.observer = observer;
    }

    dispatchDOMEvent(event) {
      if (event.data) {
        htmlevent(this.dom, event.type, event.data.x, event.data.y);
      }
    }

    update() {
      this.image = html2canvas(this.dom, canvases);
      this.needsUpdate = true;
      this.scheduleUpdate = null;
    }

    dispose() {
      if (this.observer) {
        this.observer.disconnect();
      }

      this.scheduleUpdate = clearTimeout(this.scheduleUpdate);

      super.dispose();
    }
  }

  class HTMLMesh extends THREE.Mesh {
    constructor() {
      const texture = new HTMLTexture();

      const geometry = new THREE.PlaneGeometry(
        texture.image.width * 0.001,
        texture.image.height * 0.001,
      );
      const material = new THREE.MeshBasicMaterial({
        map: texture,
        toneMapped: false,
        transparent: true,
      });

      super(geometry, material);

      function onEvent(event) {
        material.map.dispatchDOMEvent(event);
      }

      this.addEventListener('mousedown', onEvent);
      this.addEventListener('mousemove', onEvent);
      this.addEventListener('mouseup', onEvent);
      this.addEventListener('click', onEvent);

      this.dispose = function () {
        geometry.dispose();
        material.dispose();

        material.map.dispose();

        canvases.delete(dom);

        this.removeEventListener('mousedown', onEvent);
        this.removeEventListener('mousemove', onEvent);
        this.removeEventListener('mouseup', onEvent);
        this.removeEventListener('click', onEvent);
      };
    }
  }

  return new HTMLMesh();
};
